module.exports = __webpack_public_path__ + "img/symbol_6.abbe1bd8.png";